import { provideBridgeImage } from "./bridgeImages";
import { provideCountryBadge } from "./country/countryBadge";
import { provideHatchImage } from "./terrain/TerrainLayers";
import { MISSION_PREFIX, provideNeutralChip } from "./units/missionImages";
import { provideSymbolImage } from "./units/symbols";
import { provideAnnotationImage } from "./annotations/symbolStyle";

/** Images demandées par la carte (« styleimagemissing ») : symboles APP-6 « sidc:… », symbole OTAN des
 *  ponts, motifs de praticabilité (MCOO) de l'analyse du terrain et fond des étiquettes des pays fictifs. */

interface ImageHost {
  hasImage(id: string): boolean;
  addImage(
    id: string,
    image: ImageData,
    options?: {
      pixelRatio?: number;
      stretchX?: [number, number][];
      stretchY?: [number, number][];
      content?: [number, number, number, number];
    },
  ): void;
}

export function provideImage(map: ImageHost, id: string): void {
  // Pastille neutre d'un verbe sans image (niveau compagnie) : dessinée à la demande.
  if (provideNeutralChip(map, id)) return;
  // Symboles de mission : chargés au démarrage de la carte (missionImages.ts).
  if (map.hasImage(id) || id.startsWith(MISSION_PREFIX)) return;
  if (provideBridgeImage(map, id)) return;
  if (provideCountryBadge(map, id)) return;
  if (provideHatchImage(map, id)) return;
  if (provideAnnotationImage(map, id)) return;
  provideSymbolImage(map, id);
}
